import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import "./stock.scss";

type Props = {
    stockPromise?: Promise<number | null>;
    className?: string;
};

export const Stock = ({ stockPromise, className }: Props) => {
    const [stock, setStock] = useState<number | null | undefined>(undefined);
    const { t } = useGranite();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!isDefined(stockPromise)) {
            setStock(null);
        } else {
            stockPromise.then(setStock);
        }
    }, [stockPromise, setStock]);

    if (stock === null) return null;

    if (stock === undefined && isDefined(stockPromise)) {
        return (
            <div
                className={cn(`productTile__stock__skeleton`, className)}
            ></div>
        );
    }

    return (
        <div className={cn("productTile__stock", className)}>
            <i className={"las la-check mr-1"} />
            {t("productTile.stock", stock)}
        </div>
    );
};
